module.exports = __webpack_public_path__ + "static/bubble_medium-43f81123d51e9f9cbb761c3fd455284b.png";